module.exports = __webpack_public_path__ + "img/CM.3367660e.png";